import { memo } from "react";
import { GridActionsCellItem, type GridRowParams } from "@mui/x-data-grid-premium";
import Tooltip from "@mui/material/Tooltip";
import DownloadIcon from '@mui/icons-material/Download';
import { useDownloadFile } from "hooks";
import { downloadOnboardingApplication } from "features/onboarding/api";
import When from "ui/support/When";
import Loader from "ui/molecules/Loader";

const DownloadApplication = ({ id }: GridRowParams) => {
    const { isLoading, download } = useDownloadFile(() => downloadOnboardingApplication({
        userId: id
    }));
    const label = `Download Application: ${id}`;

    return (
        <GridActionsCellItem
            icon={(
                <When
                    if={isLoading}
                    then={(
                        <Loader
                            isLoading
                            slotProps={{
                                progress: {
                                    size: 16
                                }
                            }}
                        />
                    )}
                >
                    <Tooltip
                        arrow
                        title={label}
                    >
                        <DownloadIcon />
                    </Tooltip>
                </When>
            )}
            label={label}
            onClick={() => download({
                fileKey: `${id}`,
                fileName: `application_${id}.zip`
            })}
        />
    );
};

export default memo(DownloadApplication);
